import { Splide } from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';

export class MvSlider {
  constructor() {
    this.DOM = {
      sliders: document.querySelectorAll('.js-mvSlider'),
    };

    this.init();
  }

  init() {
    if( !this.DOM.sliders ) return;
    
    document.querySelector(`.js-mv__title[data-index="1"]`).classList.add('is-active');
    
    this.DOM.sliders.forEach(slider => this.initSlider(slider));
  }

  initSlider(slider) {
    const progressbar = slider.querySelector('.js-slider__progress');
    const hoverNextArea = slider.querySelector('.js-mv__pointerArea');

    const splide = new Splide(slider, this.getSplideOptions());

    if (progressbar) {
      this.setProgressbar(splide, progressbar);
    }

    if (hoverNextArea) {
      this.setHoverNextArea(splide, hoverNextArea);
    }

    splide.mount({ Intersection });
  }

  getSplideOptions() {
    return {
      type: 'loop',
      autoplay: 'pause',
      interval: 3500,
      speed: 1000,
      perMove: 1,
      gap: '1px',
      fixedWidth: '72rem',
      resetProgress: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      drag: false,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      intersection: {
        inView: { autoplay: true },
        outView: { autoplay: false },
      },
      breakpoints: {
        750: {
          fixedWidth: '37.5rem',
          gap: '2rem',
          drag: true,
        },
      },
    };
  }

  // プログレスバーの進捗を制御
  setProgressbar(splide, progressbar) {
    const segments = progressbar.querySelectorAll('.js-slider__progressBar');

    splide.on('autoplay:playing', rate => {
      const currentIndex = splide.index;

      segments.forEach((segment, index) => {
        const fill = segment.querySelector('.js-slider__progressBarFill');
        fill.style.width = index === currentIndex ? `${rate * 100}%` : '0%';
      });
    });

    splide.on('move', () => {
      this.resetProgressbar(progressbar);
      this.activateCurrentTitle(splide.index);
    });
  }

  // プログレスバーをリセット
  resetProgressbar(progressbar) {
    const segments = progressbar.querySelectorAll('.js-slider__progressBarFill');
    segments.forEach(fill => {
      fill.style.width = '0%';
    });
  }

  // スライドの内容に合わせてMVのタイトルを変更
  activateCurrentTitle(currentIndex) {
    const mvTitles = document.querySelectorAll('.js-mv__title');
    mvTitles.forEach(title => title.classList.remove('is-active'));

    const currentTitle = document.querySelector(`.js-mv__title[data-index="${currentIndex + 1}"]`);
    if (currentTitle) currentTitle.classList.add('is-active');
  }

  setHoverNextArea(splide, hoverNextArea) {
    hoverNextArea.addEventListener('click', () => splide.go('>'));
  }
}

